import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { HeavyText, HistoryTable, HistoryTableWrapper, LightText, SmallFont, TableCard } from './Style';

// Map poster images to their show dates for scroll linking
const POSTER_DATA = [
  { src: '/ephemera/2025.10.3.jpg', date: '2025-10-03' },
  { src: '/ephemera/2024.10.24.jpg', date: '2024-10-24' },
  { src: '/ephemera/2023.9.1.jpg', date: '2023-09-01' },
  { src: '/ephemera/2023.8.12.jpg', date: '2023-08-12' },
  { src: '/ephemera/2023.6.15.jpg', date: '2023-06-15' },
  { src: '/ephemera/2023.4.8.jpg', date: '2023-04-08' },
  { src: '/ephemera/2023.3.25.jpg', date: '2023-03-25' },
  { src: '/ephemera/2023.3.17.jpg', date: '2023-03-17' },
  { src: '/ephemera/2022.11.1.png', date: '2022-11-01' },
  { src: '/ephemera/2022.9.20.jpg', date: '2022-09-20' },
  { src: '/ephemera/2022.9.4.jpg', date: '2022-09-04' },
  { src: '/ephemera/2022.8.12.jpg', date: '2022-08-12' },
  { src: '/ephemera/2010.4.2.jpg', date: '2010-04-02' },
  { src: '/ephemera/2018.1.14.png', date: '2018-01-14' },
  { src: '/ephemera/2014.9.3.png', date: '2014-09-03' },
  { src: '/ephemera/2010.2.14.jpg', date: '2010-02-14' },
  { src: '/ephemera/2009.9.5.jpg', date: '2009-09-05' },
  { src: '/ephemera/2009.8.8.jpg', date: '2009-08-08' },
  { src: '/ephemera/2009.8.7.jpg', date: '2009-08-07' },
  { src: '/ephemera/2009.7.15.jpg', date: '2009-07-15' },
  { src: '/ephemera/2009.6.27.jpg', date: '2009-06-27' },
  { src: '/ephemera/2009.6.18.jpg', date: '2009-06-18' },
  { src: '/ephemera/2009.5.29.jpg', date: '2009-05-29' },
  { src: '/ephemera/2009.4.9.png', date: '2009-04-09' },
  { src: '/ephemera/2009.3.20.jpg', date: '2009-03-20' },
  { src: '/ephemera/2008.9.7.jpg', date: '2008-09-07' },
  { src: '/ephemera/2008.8.23.jpg', date: '2008-08-23' },
  { src: '/ephemera/2008.11.8.jpg', date: '2008-11-08' },
  { src: '/ephemera/2008.8.21.jpg', date: '2008-08-21' },
  { src: '/ephemera/2008.5.1.jpg', date: '2008-05-01' },
  { src: '/ephemera/2008may29.jpg', date: '2008-05-29' },
  { src: '/ephemera/2008.jan24.jpg', date: '2008-01-24' },
  { src: '/ephemera/poster.2007.12.15.jpg', date: '2007-12-15' },
  { src: '/ephemera/2007.7.23.jpg', date: '2007-07-23' },
  { src: '/ephemera/2007.6.9.jpg', date: '2007-06-09' },
  { src: '/ephemera/2007may11.jpg', date: '2007-05-07' },
  { src: '/ephemera/mikrofest.jpg', date: '2007-04-14' },
  { src: '/ephemera/poster.1.11.2007.jpg', date: '2007-01-11' },
  { src: '/ephemera/2006.12.30.jpg', date: '2006-12-30' },
  { src: '/ephemera/Farm-Show.jpg', date: '2006-10-08' },
];

// Artist name -> link mapping for auto-linking in notes
const ARTIST_LINKS = {
  'Little Angry': 'https://www.instagram.com/littleangry/',
  'Briana Marela': 'https://www.instagram.com/brianamarela/',
  'tUnEyArDs': 'https://www.instagram.com/tuneyards/',
  'TuNe-YaRds': 'https://www.instagram.com/tuneyards/',
  'Mountain Man': 'https://www.instagram.com/mountainmanband/',
  'Tiny Vipers': 'https://www.instagram.com/tiny_vipers/',
  'Grouper': 'https://www.instagram.com/grouperepuorg/',
  'Vetiver': 'https://www.instagram.com/vetiverse/',
  'LAKE': 'https://www.instagram.com/laketheband/',
  'Eleanor Murray': 'https://www.instagram.com/eleanor.plays/',
  'Matt Mehlan': 'https://www.instagram.com/matt_mehlan/',
  'Michael Rocketship': 'https://www.instagram.com/michaelprincecoleman/',
  'Lori Goldston': 'https://www.instagram.com/legoldston/',
  'Arrington de Dionyso': 'https://www.instagram.com/arringtondedionyso/',
  'Arrington de Dionysio': 'https://www.instagram.com/arringtondedionyso/',
  'Public Speaking': 'https://www.instagram.com/public__speaking/',
  'Ajaï': 'https://www.instagram.com/__ajai__/',
  'Pools': 'https://www.instagram.com/ancientpools/',
  'Karl Blau': 'https://www.instagram.com/hownowkarlblau/',
  'Ami Dang': 'https://www.instagram.com/amidang/',
  'Viking Moses': 'https://www.instagram.com/vikingmoses/',
};

const CollageContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  max-width: 600px;
  margin: 0 auto 2rem;
  padding: 0 1rem;

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const CollageCell = styled.div`
  aspect-ratio: 1;
  border-radius: 4px;
  overflow: hidden;
  background: var(--bg-secondary);
  cursor: pointer;
  position: relative;

  &:hover img {
    opacity: 1;
    transform: scale(1.02);
  }
`;

const ImageLinkWrapper = styled.span`
  position: relative;
  display: inline;
`;

const PreviewOverlay = styled.div`
  position: fixed;
  z-index: 1000;
  pointer-events: none;
  max-width: 300px;
  max-height: 400px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  background: var(--bg-card);
  padding: 4px;
  opacity: ${props => props.$visible ? 1 : 0};
  transform: ${props => props.$visible ? 'scale(1)' : 'scale(0.95)'};
  transition: opacity 0.2s ease, transform 0.2s ease;

  img {
    display: block;
    max-width: 100%;
    max-height: 392px;
    object-fit: contain;
  }
`;

const CollageImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: ${props => props.$visible ? 0.85 : 0};
  transition: opacity 0.8s ease-in-out, transform 0.3s ease;
  position: absolute;
  top: 0;
  left: 0;
`;

function PosterCollage() {
  const [cells, setCells] = useState([]);

  useEffect(() => {
    // Shuffle and pick 6 random posters
    const shuffled = [...POSTER_DATA].sort(() => Math.random() - 0.5);
    const initial = shuffled.slice(0, 6).map(poster => ({
      current: poster,
      previous: null,
      transitioning: false
    }));
    setCells(initial);

    // Rotate one poster every 3 seconds
    const interval = setInterval(() => {
      setCells(prev => {
        const currentSrcs = new Set(prev.map(c => c.current.src));
        const available = POSTER_DATA.filter(p => !currentSrcs.has(p.src));

        if (available.length === 0) return prev;

        const randomIndex = Math.floor(Math.random() * prev.length);
        const randomNewPoster = available[Math.floor(Math.random() * available.length)];

        const newCells = [...prev];
        newCells[randomIndex] = {
          current: randomNewPoster,
          previous: prev[randomIndex].current,
          transitioning: true
        };

        // Clear previous after transition completes
        setTimeout(() => {
          setCells(current => {
            const updated = [...current];
            if (updated[randomIndex]) {
              updated[randomIndex] = {
                ...updated[randomIndex],
                previous: null,
                transitioning: false
              };
            }
            return updated;
          });
        }, 800);

        return newCells;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const scrollToShow = (date) => {
    const element = document.getElementById(`show-${date}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Flash highlight
      element.style.background = 'rgba(255, 255, 255, 0.15)';
      setTimeout(() => {
        element.style.background = '';
      }, 1500);
    }
  };

  return (
    <CollageContainer>
      {cells.map((cell, index) => (
        <CollageCell key={index} onClick={() => scrollToShow(cell.current.date)}>
          {cell.previous && (
            <CollageImage
              src={cell.previous.src}
              alt="Show poster"
              $visible={false}
            />
          )}
          <CollageImage
            src={cell.current.src}
            alt="Show poster"
            $visible={true}
          />
        </CollageCell>
      ))}
    </CollageContainer>
  );
}

function History() {
  const [data, setData] = useState([]);
  const [preview, setPreview] = useState({ visible: false, url: '', x: 0, y: 0 });

  useEffect(() => {
    fetch('/shows.json')
      .then(response => response.json())
      .then(shows => setData(shows))
      .catch(err => console.error('Error loading shows:', err));
  }, []);

  const isImageUrl = (url) => {
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
  };

  const handleMouseEnter = (e, url) => {
    const rect = e.target.getBoundingClientRect();
    const x = Math.min(rect.left, window.innerWidth - 320);
    const y = Math.max(rect.bottom + 10, 10);
    setPreview({ visible: true, url, x, y: Math.min(y, window.innerHeight - 420) });
  };

  const handleMouseLeave = () => {
    setPreview(prev => ({ ...prev, visible: false }));
  };

  // Render notes with linked artist names
  const renderNotes = (notes) => {
    if (!notes) return null;

    // Sort artists by name length (longest first) to avoid partial matches
    const sortedArtists = Object.keys(ARTIST_LINKS).sort((a, b) => b.length - a.length);

    // Create regex pattern for all artists
    const pattern = new RegExp(`(${sortedArtists.map(a => a.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'g');

    // Split notes by artist names
    const parts = notes.split(pattern);

    return parts.map((part, idx) => {
      if (ARTIST_LINKS[part]) {
        return (
          <a key={idx} href={ARTIST_LINKS[part]} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  // Format date for display (YYYY-MM-DD -> Month DD, YYYY)
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr + 'T00:00:00');
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Render ephemera links
  const renderEphemera = (ephemera) => {
    if (!ephemera || ephemera.length === 0) return null;

    return ephemera.map((item, idx) => {
      if (item.url) {
        const isImage = isImageUrl(item.url);
        return (
          <span key={idx}>
            {idx > 0 && ', '}
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              onMouseEnter={isImage ? (e) => handleMouseEnter(e, item.url) : undefined}
              onMouseLeave={isImage ? handleMouseLeave : undefined}
            >
              {item.label}
            </a>
          </span>
        );
      }
      return (
        <span key={idx}>
          {idx > 0 && ', '}
          {item.label}
        </span>
      );
    });
  };

  return (
    <div>
      <PosterCollage />
      <PreviewOverlay
        $visible={preview.visible}
        style={{ left: preview.x, top: preview.y }}
      >
        {preview.url && <img src={preview.url} alt="Preview" />}
      </PreviewOverlay>
      <TableCard>
      <h1>History</h1>
      <LightText><SmallFont>
      <HistoryTableWrapper>
      <HistoryTable>
        <thead>
          <tr>
            <th>Date</th>
            <th>Venue</th>
            <th>City</th>
            <th>Notes</th>
            <th>Ephemera</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index} id={`show-${item.date}`} style={{ transition: 'background 0.3s ease' }}>
              <td>{formatDate(item.date)}</td>
              <td><HeavyText>{item.venue}</HeavyText></td>
              <td>{item.city}</td>
              <td>{renderNotes(item.notes)}</td>
              <td>{renderEphemera(item.ephemera)}</td>
            </tr>
          ))}
        </tbody>
      </HistoryTable>
      </HistoryTableWrapper>
      </SmallFont></LightText>
      </TableCard>
    </div>
  );
}

export default History;